import { createAction, props } from "@ngrx/store";
import { EstruturaRetornoDadosOutputDto } from "src/app/domain/DTOs/output/estrutura-retorno-dados.output.dto";
import { ServicoOutputDto } from "src/app/domain/DTOs/output/servicos/servico.output.dto";

const actionName = "[ ListarServicos ] Listar servicos";

export const listarServicos = createAction(
  actionName
);

export const listarServicosSuccess = createAction(
  `${actionName} - Sucesso`,
  props<{ response: EstruturaRetornoDadosOutputDto<ServicoOutputDto[]> }>()
);

export const listarServicosFailure = createAction(
  `${actionName} - Falha`,
  props<{ response: EstruturaRetornoDadosOutputDto<ServicoOutputDto[]> }>()
);

export const listarServicosFinish = createAction(
  `${actionName} - Concluir`
);
